import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgUnCheck = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F1F4FB"
      d="M20 33c7.18 0 13-5.82 13-13S27.18 7 20 7 7 12.82 7 20s5.82 13 13 13"
    />
    <path
      fill="#00215B"
      d="M20 9C12.82 9 7 14.82 7 22s5.82 13 13 13 13-5.82 13-13h1c0 7.732-6.268 14-14 14S6 29.732 6 22 12.268 8 20 8z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgUnCheck);

export default ForwardRef;
